import { Fee } from '@/views/checkout/interfaces';
import { FEE_TYPE } from '@/constants/fee-type';
import { SurchargeInfo } from '@/core/payment-card/interfaces';
import { PaymentMethod } from "@/core/payment-methods/constants";
import { SURCHARGE_FEE_CONFIG } from "@/constants/fee";

export function updateSurcharge(fees: Array<Fee>, surcharge: SurchargeInfo | null) {
    const surchargeAmount = surcharge?.amount ?? 0;
    const surchargeAvailable = hasSurcharge(fees);

    if (!surchargeAmount) {
        return surchargeAvailable
            ? removeSurcharge(fees)
            : fees;
    }

    if (surchargeAvailable) {
        return applySurcharge(fees, surchargeAmount);
    }

    return [...fees, { type: FEE_TYPE.Surcharge, amount: surchargeAmount }];
}

export function hasSurcharge(fees: Array<Fee>) {
    return fees.some((fee) => fee.type === FEE_TYPE.Surcharge);
}

export function getSurchargeAmount(fees: Array<Fee>) {
    const surcharge = getSurcharge(fees);

    return surcharge?.amount || 0;
}

export function supportsSurcharge(paymentMethod: PaymentMethod | null) {
    if (!paymentMethod) {
        return false;
    }

    return SURCHARGE_FEE_CONFIG.paymentMethods?.includes(paymentMethod.id);
}

function getSurcharge(fees: Array<Fee>): Fee | undefined {
    return fees.find((fee) => fee.type === FEE_TYPE.Surcharge);
}

function removeSurcharge(fees: Array<Fee>) {
    return fees.filter((fee) => fee.type !== FEE_TYPE.Surcharge);
}

function applySurcharge(fees: Array<Fee>, surchargeAmount: number) {
    return fees.map((fee) =>
        fee.type === FEE_TYPE.Surcharge
            ? { ...fee, amount: surchargeAmount }
            : fee
    );
}
